<div
  class="modal-dialog goreact-modal"
  data-cy="marker-set-dailog"
  tabindex="0"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="dialogTitleId"
  (keydown.enter)="onEnterPress()">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h3 class="modal-title" [id]="dialogTitleId">
        {{(data.markerSet ? 'modal-activity-editor-marker-set-editor_edit-markers' : 'modal-activity-editor-marker-set-editor_create-markers') | translate}}
      </h3>
      <button
        class="close-btn"
        type="button"
        [attr.aria-label]="'common_close' | translate"
        (click)="dismiss()"
        >
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body" cdkScrollable>
      <div class="form-div" [formGroup]="form" #content goRequiredFieldsNote>
        <mat-form-field appearance="outline" class="title-field">
          <mat-label translate="tag-editor_title"></mat-label>
          <input
            matInput
            formControlName="title"
            data-cy="tag-set-title"
            maxlength="255"
            />
          @if (form.controls.title.hasError('required')) {
            <mat-error
              translate="title-required">
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="description-textarea">
          <mat-label translate="tag-editor_description"></mat-label>
          <textarea matInput formControlName="description" rows="2" maxlength="191" data-cy="tag-set-description"></textarea>
        </mat-form-field>
        <div class="tag-form" role="table">
          <div class="headers" role="row">
            <!-- spacing for handle -->
            <span role="presentation"></span>
            <span
              id="tag-editor-header-color"
              role="columnheader"
              translate="tag-editor_header-color"
            class="header-color"></span>
            <span class="header-name" role="columnheader">
              <span class="required-color">*</span>
              <span
                id="tag-editor-header-name"
                translate="tag-editor_header-name"
              class="header-name"></span>
            </span>
            <span
              id="tag-editor-header-abbr"
              role="columnheader"
              translate="tag-editor_header-abbr"
            class="header-abbr"></span>
            <span
              id="tag-editor-header-comment"
              role="columnheader"
              translate="tag-editor_header-comment"
            class="header-comment"></span>
            <!-- spacing for actions -->
            <span role="presentation"></span>
          </div>
          <div class="tags-container" role="rowgroup">
            <!-- Tag creation -->
            @if (showTagCreator()) {
              <div
                class="tag tag-creator"
                role="row"
                [ngClass]="{ 'hasError': !newTagForm.valid }"
                [formGroup]="newTagForm"
                #newTagFormContent
                >
                <div class="sticky-column" role="cell">
                  <span class="field-label" translate="tag-editor_header-color"></span>
                  <!-- Tag color -->
                  <color-menu
                    [selectedColor]="newTagColor"
                    [colors]="colors"
                    (onSelect)="changeNewColor($event)"
                  ></color-menu>
                </div>
                <!-- Tag name -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" role="cell">
                  <mat-label class="field-label">
                    <span class="required-color">*</span>
                    <span translate="tag-editor_header-name"></span>
                  </mat-label>
                  <input
                    matInput
                    id="tag-creator-input-name"
                    formControlName="newTagName"
                    (input)="newNameChanged($event)"
                    (keyup.enter)="addNewMarker(newTagForm)"
                    maxlength="30"
                    data-cy="new-tag-name"
                    />
                  @if (newTagForm.controls.newTagName.hasError('required')) {
                    <mat-error
                      translate="tag-editor_name-required">
                    </mat-error>
                  }
                  @if (newTagForm.controls.newTagName.hasError('duplicate')) {
                    <mat-error
                      translate="tag-editor_name-duplicate">
                    </mat-error>
                  }
                </mat-form-field>
                <!-- Tag abbreviation -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" role="cell">
                  <mat-label class="field-label" translate="tag-editor_header-abbr"></mat-label>
                  <input
                    matInput
                    id="tag-creator-input-abbreviation"
                    formControlName="newTagAbbreviation"
                    (keyup.enter)="addNewMarker(newTagForm)"
                    maxlength="2"
                    data-cy="new-tag-abbr"
                    />
                </mat-form-field>
                <!-- Tag preset comment -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" role="cell">
                  <mat-label class="field-label" translate="tag-editor_header-comment"></mat-label>
                  <input
                    matInput
                    id="tag-creator-input-comment"
                    formControlName="newTagComment"
                    (keyup.enter)="addNewMarker(newTagForm)"
                    maxlength="191"
                    data-cy="new-tag-comment"
                    />
                </mat-form-field>
                <div class="marker-action-cell" role="cell">
                  <button
                    type="button"
                    class="add-btn icon-btn ficon-add"
                    [attr.aria-label]="'modal-activity-editor-marker-set-editor_add-marker' | translate"
                    [focusOnFirstInvalidField]="{ formGroup: newTagForm, formWrapper: newTagFormContent }"
                    (click)="addNewMarker(newTagForm)"
                  ></button>
                </div>
              </div>
            }

            @if (markers.length) {
              <div
                cdkDropList
                class="marker-cards"
                cdkDropListAutoScrollStep="24"
                (cdkDropListDropped)="drop($event)">
                @for (marker of markers; track marker; let i = $index) {
                  <div
                    #listItem
                    cdkDrag
                    tabindex="0"
                    class="marker-card"
                    [cdkDragPreviewClass]="responsiveClassList"
                    [ngClass]="{ 'hasError': !form.controls['tagName' + marker.instance].valid }"
                    role="row"
                    [attr.aria-label]="'aria-ng-sortable_inform-reorderable-name' | translate: {name: marker.tag_name}"
                    accessibleDropList
                    [count]="markers.length"
                    [currentIndex]="i"
                    [name]="marker.tag_name"
                    [itemId]="marker.instance"
                    (activeItemChange)="onActiveItemChange($event)"
                    (cancelReorder)="onCancelReorder($event)"
                    (finalizePosition)="onFinalizePosition()">
                    <div class="marker-card-handle" cdkDragHandle role="cell">
                      <i class="marker-card-drag-handle ficon-app-gripper-dots-vertical"></i>
                    </div>
                    <div class="sticky-column" role="cell">
                      <span class="field-label" translate="tag-editor_header-color"></span>
                      <color-menu
                        [abbreviation]="marker.tag_abbreviation ? marker.tag_abbreviation : marker.tag_name | twoLetters"
                        [selectedColor]="findColor(marker.tag_color)"
                        [colors]="colors"
                        (onSelect)="onColorSelect($event, marker)"
                      ></color-menu>
                    </div>
                    <!-- Tag name -->
                    <mat-form-field appearance="outline" class="outlined-when-focused" subscriptSizing="dynamic" role="cell">
                      <mat-label class="field-label">
                        <span class="required-color">*</span>
                        <span translate="tag-editor_header-name"></span>
                      </mat-label>
                      <input
                        matInput
                        (input)="onNameChange($event, marker)"
                        class="existingName"
                        [formControlName]="'tagName' + marker.instance"
                        maxlength="30"
                        />
                      @if (form.controls['tagName' + marker.instance].hasError('required')) {
                        <mat-error
                          translate="tag-editor_name-required">
                        </mat-error>
                      }
                      @if (form.controls['tagName' + marker.instance].hasError('duplicate')) {
                        <mat-error
                          translate="tag-editor_name-duplicate">
                        </mat-error>
                      }
                    </mat-form-field>
                    <!-- Tag abbreviation -->
                    <mat-form-field appearance="outline" class="outlined-when-focused" subscriptSizing="dynamic" role="cell">
                      <mat-label class="field-label" translate="tag-editor_header-abbr"></mat-label>
                      <input
                        matInput
                        (input)="onAbbreviationChange($event, marker)"
                        class="existingAbbreviation"
                        [formControlName]="'tagAbbreviation' + marker.instance"
                        maxlength="2"
                        />
                    </mat-form-field>
                    <!-- Tag preset comment -->
                    <mat-form-field appearance="outline" class="outlined-when-focused" subscriptSizing="dynamic" role="cell">
                      <mat-label class="field-label" translate="tag-editor_header-comment"></mat-label>
                      <input
                        matInput
                        (input)="onCommentChange($event, marker)"
                        class="existingComment"
                        [formControlName]="'tagComment' + marker.instance"
                        maxlength="191"
                        />
                    </mat-form-field>
                    <!-- Remove tag button -->
                    <div class="marker-action-cell" role="cell">
                      <button
                        type="button"
                        [attr.aria-label]="'modal-activity-editor-marker-set-editor_remove-marker' | translate"
                        class="remove-button icon-btn ficon-app-x"
                        (click)="removeTag(marker)"
                      ></button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="goreact-modal-footer">
      <button
        type="button"
        (click)="dismiss()"
        translate="common_cancel"
        class="goreact-btn tertiary-btn cancel-btn"
      ></button>
      <button
        type="submit"
        data-cy="save-marker-set"
        class="goreact-btn primary-btn submit-btn"
        [focusOnFirstInvalidField]="{ formGroup: form, formWrapper: content }"
        (click)="submit(form)"
        translate="common_save-and-close"
      ></button>
    </div>
  </div>
</div>
